import * as React from 'react'
import {useLocation} from '@reach/router'
import Fab from '@mui/material/Fab'
import Stack from '@mui/material/Stack'
import LinkedIn from '@mui/icons-material/LinkedIn'
import Twitter from '@mui/icons-material/Twitter'
import LinkIcon from '@mui/icons-material/Link'
import Popover from '@mui/material/Popover'
import {Typography} from '@mui/material'

interface Props {
  children: React.ReactNode
  href?: string
}

const ShareButton = ({children, href}: Props) => (
  <Fab
    aria-label="add"
    href={href}
    sx={{
      boxShadow: 'none',
      background: 'transparent',
      border: '1px solid',
      borderColor: 'text.primary',
      color: 'text.primary',
    }}
  >
    {children}
  </Fab>
)

const TWITTER_URL = 'https://twitter.com/intent/tweet?url='
const LINKEDIN_URL = 'https://www.linkedin.com/sharing/share-offsite/?url='

const ShareBlock = () => {
  const {href} = useLocation()
  const [anchorEl, setAnchorEl] = React.useState<SVGSVGElement | null>(null)

  const handleClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <Stack spacing={2} sx={{textAlign: 'center', alignItems: 'center'}}>
      <Typography variant="body1">Share</Typography>
      <ShareButton href={`${TWITTER_URL}${encodeURI(href)}`}>
        <Twitter color="inherit" fontSize="large" />
      </ShareButton>
      <ShareButton href={`${LINKEDIN_URL}${encodeURI(href)}`}>
        <LinkedIn color="inherit" fontSize="large" />
      </ShareButton>
      <ShareButton>
        <LinkIcon
          color="inherit"
          fontSize="large"
          onClick={(e: React.MouseEvent<SVGSVGElement>) => {
            handleClick(e)
            navigator.clipboard.writeText(href)
          }}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <Typography sx={{p: 2}}>
            The Page link has been copied to clipboard.
          </Typography>
        </Popover>
      </ShareButton>
    </Stack>
  )
}

export default ShareBlock
